/**
 * Liste sayfalarında sayfa numarasını URL'de (?p=) tutar.
 * Kullanan bileşende `perPage`, `dataCounts` ve `getDataList()` bulunmalı;
 * `getDataList` isteği `currentPage`'e göre göndermeli ve sonunda `checkPageRange()` çağırmalı.
 */
const parsePage = value => {
  const page = Number(value)
  return Number.isInteger(page) && page > 0 ? page : 1
}

export default {
  data() {
    return {
      currentPage: parsePage(this.$route.query.p),
      listPath: this.$route.path,
    }
  },
  watch: {
    $route(to) {
      // Liste dışına çıkarken (geçiş animasyonu sürerken) tetiklenmesin
      if (to.path !== this.listPath) {
        return
      }
      this.currentPage = parsePage(to.query.p)
    },
    currentPage(val) {
      if (parsePage(this.$route.query.p) !== val) {
        this.$router.push({ query: this.pageQuery(val) })
      }
      this.$store.commit('app/SET_LIST_PAGE', { path: this.listPath, page: val })
      this.getDataList()
    },
  },
  created() {
    this.$store.commit('app/SET_LIST_PAGE', { path: this.listPath, page: this.currentPage })
  },
  methods: {
    pageQuery(page) {
      return { ...this.$route.query, p: page > 1 ? String(page) : undefined }
    },
    checkPageRange() {
      const lastPage = Math.max(1, Math.ceil(this.dataCounts / this.perPage))
      if (this.currentPage > lastPage) {
        this.$router.replace({ query: this.pageQuery(lastPage) })
      }
    },
    filterDataList() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        this.getDataList()
      }
    },
  },
}
